import React from 'react';
import { useTranslation } from 'react-i18next';

import DataGrid from 'components/Grids/DataGrid';
import { ICONS_MAP } from 'constants/icons';
import { appReactMemo } from 'hocs';
import { useGetReports } from 'queries/reports';
import { ITabComponent } from 'routes/pages/AuthorizedStack/Invoices/constants';

import { RefreshButton } from './styled';
import { useReportsGridData } from './useReportsGridData';

interface IReportGridProps extends ITabComponent {
  path?: string;
  refreshMargin?: boolean;
}

const ReportGrid = ({ children, path, refreshMargin }: IReportGridProps) => {
  const { t } = useTranslation();

  const { data, isFetching, isLoading, refetch } = useGetReports({ path });
  const columns = useReportsGridData({ data, path });

  const childrenData = {
    content: (
      <DataGrid
        columns={columns}
        data={data || []}
        isBottomToolbar={false}
        isFetching={isFetching}
        isLoading={isLoading}
        isTopToolbar={false}
        minHeight={360}
        notVirtualized={false}
      />
    ),
    createComponent: (
      <RefreshButton
        $marginBottom={refreshMargin}
        iconSize={20}
        onClick={refetch as never}
        startIcon={<ICONS_MAP.ArrowCircle />}
        testIds={{ container: 'reportsModalRefreshButton' }}
        variant='outlined'
      >
        {t('common.refresh')}
      </RefreshButton>
    ),
  };

  return children(childrenData);
};

export default appReactMemo(ReportGrid);
